/* Estimated delivery date — origin: Chennai, Tamil Nadu.
   Zone lookup is by the first 3 digits of the Indian PIN code (the sorting district).
   Edit ZONE_MAP to move a region between zones. Order of evaluation is A -> D -> C -> B -> E. */

(function () {
  'use strict';

  var ZONE_MAP = {
    // Zone A — within city (Chennai GPO series)
    A: [[600, 600]],

    // Zone D — Kerala, North East, Jammu & Kashmir + Ladakh
    D: [
      [670, 695],   // Kerala (+ Lakshadweep, routed via 682)
      [737, 737],   // Sikkim
      [781, 788],   // Assam
      [790, 792],   // Arunachal Pradesh
      [793, 794],   // Meghalaya
      [795, 795],   // Manipur
      [796, 796],   // Mizoram
      [797, 798],   // Nagaland
      [799, 799],   // Tripura
      [180, 185],   // Jammu
      [190, 194]    // Kashmir + Ladakh
    ],

    // Zone C — metro to metro
    C: [
      [110, 110],   // Delhi
      [380, 380],   // Ahmedabad
      [400, 400],   // Mumbai
      [411, 411],   // Pune
      [500, 500],   // Hyderabad
      [560, 560],   // Bengaluru
      [700, 700]    // Kolkata
      // Add [201,201] Noida / [122,122] Gurugram / [401,401] Thane if you treat NCR & MMR as metro.
    ],

    // Zone B — rest of Tamil Nadu (601-643 also covers Puducherry & Karaikal)
    B: [[601, 643]]
  };

  var ZONE_ORDER = ['A', 'D', 'C', 'B'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var STORAGE_KEY = 'dxe_pincode';

  function zoneFor(pincode) {
    var prefix = parseInt(String(pincode).slice(0, 3), 10);
    for (var i = 0; i < ZONE_ORDER.length; i++) {
      var key = ZONE_ORDER[i];
      var ranges = ZONE_MAP[key] || [];
      for (var j = 0; j < ranges.length; j++) {
        if (prefix >= ranges[j][0] && prefix <= ranges[j][1]) return key;
      }
    }
    return 'E';
  }

  /* A Date whose local getters read IST wall-clock time, regardless of the shopper's timezone. */
  function nowIST() {
    var d = new Date();
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 330 * 60000);
  }

  function iso(d) {
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
  }

  function isWorkingDay(d, cfg) {
    var wd = d.getDay();
    if (wd === 0) return false;
    if (wd === 6 && !cfg.saturdayWorking) return false;
    return cfg.holidays.indexOf(iso(d)) === -1;
  }

  function addWorkingDays(from, count, cfg) {
    var d = new Date(from.getTime());
    var added = 0;
    var guard = 0;
    while (added < count && guard < 400) {
      d.setDate(d.getDate() + 1);
      if (isWorkingDay(d, cfg)) added++;
      guard++;
    }
    return d;
  }

  function nextWorkingDay(from, cfg) {
    return addWorkingDays(from, 1, cfg);
  }

  function formatDate(d) {
    return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
  }

  function msUntilCutoff(now, cfg) {
    var cutoff = new Date(now.getTime());
    cutoff.setHours(cfg.cutoffHour, cfg.cutoffMinute, 0, 0);
    return cutoff.getTime() - now.getTime();
  }

  function formatCountdown(ms) {
    var mins = Math.floor(ms / 60000);
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    if (h > 0) return h + 'h ' + m + 'm';
    return m + 'm';
  }

  function estimate(pincode, cfg) {
    var now = nowIST();
    var zoneKey = zoneFor(pincode);
    var zone = cfg.zones[zoneKey];

    var beforeCutoff = msUntilCutoff(now, cfg) > 0;
    var sameDayStart = isWorkingDay(now, cfg) && beforeCutoff;

    // First working day the order can be picked for packing.
    var base = sameDayStart ? new Date(now.getTime()) : nextWorkingDay(now, cfg);
    if (!sameDayStart) {
      while (!isWorkingDay(base, cfg)) base = nextWorkingDay(base, cfg);
    }

    // Hand-over to courier.
    var shipDate = addWorkingDays(base, Math.max(0, cfg.processingDays - 1), cfg);

    return {
      zoneKey: zoneKey,
      zoneLabel: zone.label,
      shipDate: shipDate,
      min: addWorkingDays(shipDate, zone.min, cfg),
      max: addWorkingDays(shipDate, zone.max, cfg),
      cutoffMs: sameDayStart ? msUntilCutoff(now, cfg) : 0
    };
  }

  function render(root, cfg, pincode) {
    var out = root.querySelector('[data-dxe-result]');
    out.hidden = false;

    if (!pincode) {
      out.innerHTML = '<p class="dxe__meta dxe__error">' + cfg.copy.empty + '</p>';
      return;
    }
    if (!/^[1-9][0-9]{5}$/.test(pincode)) {
      out.innerHTML = '<p class="dxe__meta dxe__error">' + cfg.copy.invalid + '</p>';
      return;
    }

    var r = estimate(pincode, cfg);
    var window_ =
      r.min.getTime() === r.max.getTime()
        ? formatDate(r.min)
        : formatDate(r.min) + ' &ndash; ' + formatDate(r.max);

    var html =
      '<p class="dxe__line">' +
      cfg.copy.prefix +
      ' <span class="dxe__date">' +
      window_ +
      '</span></p>' +
      '<p class="dxe__route"><span>Chennai</span><span>' +
      r.zoneLabel +
      '</span><span>' +
      pincode +
      '</span></p>';

    if (cfg.showCountdown && r.cutoffMs > 0) {
      html +=
        '<p class="dxe__meta dxe__cutoff">' +
        cfg.copy.cutoffLine.replace('{time}', formatCountdown(r.cutoffMs)) +
        '</p>';
    } else {
      html += '<p class="dxe__meta">Dispatches ' + formatDate(r.shipDate) + '</p>';
    }

    out.innerHTML = html;

    root.dispatchEvent(
      new CustomEvent('delivery:estimated', {
        bubbles: true,
        detail: { pincode: pincode, zone: r.zoneKey, min: r.min, max: r.max }
      })
    );
  }

  function init(root) {
    if (root.dataset.dxeReady) return;
    root.dataset.dxeReady = 'true';

    var configEl = root.querySelector('[data-dxe-config]');
    if (!configEl) return;

    var cfg;
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    cfg.holidays = (cfg.holidays || []).map(function (h) {
      return String(h).trim();
    });

    var input = root.querySelector('[data-dxe-input]');
    var button = root.querySelector('[data-dxe-submit]');

    function run() {
      var value = input.value.replace(/\D/g, '').slice(0, 6);
      input.value = value;
      if (cfg.rememberPincode && /^[1-9][0-9]{5}$/.test(value)) {
        try {
          localStorage.setItem(STORAGE_KEY, value);
        } catch (e) {}
      }
      render(root, cfg, value);
    }

    button.addEventListener('click', run);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        run();
      }
    });

    if (cfg.rememberPincode) {
      var saved = null;
      try {
        saved = localStorage.getItem(STORAGE_KEY);
      } catch (e) {}
      if (saved) {
        input.value = saved;
        render(root, cfg, saved);
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor + AJAX cart drawer re-renders
  document.addEventListener('shopify:section:load', boot);

  window.DeliveryEstimate = { zoneFor: zoneFor, estimate: estimate };
})();